import { BankIdApiAuthDto } from "@api-types/integrations/BankIdApiAuthDto";
import {
	getMvcApplicationHeaders,
	getWebApiUrl,
	httpClient,
	UserTypes,
} from "@utils";

export class BankIdMvcService {
	private static get baseUrl(): string {
		return `${getWebApiUrl()}/api/bankid`;
	}

	static getRequestHeaders = (
		user: UserTypes = UserTypes.PRIMARY
	): HeadersInit => {
		const appHeaders = getMvcApplicationHeaders(user);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Web-Device" as keyof HeadersInit] = "CapacitorApp";
		return appHeaders;
	};

	static async getInitialQrCodeData(): Promise<BankIdApiAuthDto> {
		const headers = this.getRequestHeaders();
		const url = `${this.baseUrl}/qrcode`;

		return httpClient.get(url, { ...headers }, { responseType: "json" });
	}

	static async getRefreshedQrCode(qrId: string) {
		const headers = this.getRequestHeaders();
		const url = `${this.baseUrl}/qrcode/${qrId}`;

		return httpClient.get(url, { ...headers });
	}
}
